var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOctopus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "iconify iconify--noto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.07 41.61s31.49-5.44 33.32-3.05 2.29 9.59 1.31 13.66c-.99 4.08-4.65 10.37-15.35 13.33-8.99 2.48-12.01 2.49-16.66 5.26-3.71 2.21-9.1 18.11-9.95 20.37s-7.04 11.12-19.99 9.29C48.1 98.67 40.34 86.8 43.02 75.12s45.05-33.51 45.05-33.51",
    fill: "#a92813"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.12 70.75s-17.6.42-23.09-5.35-11.26-18.58-12.81-28.86-6.62-16.33-9.01-17.88-4.86-1.97-5.14-.42 4.07 6.73 4.86 9.15c1.97 6.05.88 20.13 2.53 26.61 1.69 6.63 3.03 8.9 6.76 13.23 2.78 3.23 7.18 6.34 7.18 6.34s-17.03 4.08-21.82-.99-4.22-9.29-3.8-11.4 3.8-7.88 2.82-8.45c-.99-.56-7.18 4.22-8.02 10.56s1.25 11.62 4.79 15.49c4.61 5.03 13.34 5.88 18.41 5.46s10.17-2.08 10.17-2.08-.14 20.69-10 20.55c-7.46-.11-8.31-2.53-9.01-3.8s-1.43-2.32-1.06 1.72c.25 2.67 3.38 10.91 13.2 8.8 8.32-1.79 13.47-9.44 15.17-11.79 1.87-2.57 6.19-8.45 6.19-8.45s-1.67 11.43-1.31 19.52c.15 3.38 1.03 11.31 7.23 13.98 6.19 2.67 14.11-.67 15.52-6.02s-1.44-8.34-1.87-8.76-2.39 6.05-2.39 6.05-5.07 3.38-7.04.99.42-20.98.7-24.92 4.36-.14 5.77 1.83 3.7 6.86 7.18 10.28c5.74 5.65 11.97 8.1 20.82 7.42 9.22-.71 14.98-4.33 18.07-8.97 3.1-4.65 3.77-9.26 2.78-10.1s-7.74 7.29-9.15 8.41c-1.41 1.13-15.49 0-17.46 0s-2.39-3.52-2.39-3.52 8.02-2.11 10.84-4.22 10.56-6.55 11.12-19.15c.43-9.72 0-35.81.99-40.03s4.74-7.79 3.89-9.2-4.6.94-5.16 1.36-6.48 3.24-6.62 8.31-1.83 41.25-4.65 44.2c-2.82 2.96-11.97 8.87-17.03 8.17-5.07-.69-18.16-14.07-18.16-14.07",
    fill: "#ffa8a8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48 90.32c-1.69-.14-3.1 2.11-4.79 3.38s-5.07 4.5-13.94 4.22-14.78-10-14.78-10 2.82.28 6.05-.56c3.24-.84 8.38-3.59 11.61-9.43 3.85-6.94 2.99-24.07 3.03-31.68.05-10.51 3.47-16.1 4.79-17.88 2.25-3.05 5.82-4.79 5.96-5.77.14-.99-4.46-.42-7.09 1.13-2.92 1.72-4.36 3.66-4.36 3.66s-6.76-.7-10.42-.7-10.69.54-16.82 1.97c-7.53 1.76-13.16 6.05-14.71 6.34 0 0-5-4.97-13.23.7-8.59 5.91-2.39 18.44-2.39 18.44s-.42 1.81-2.67 2.39c-3.24.84-8.09-2.32-9.85-7.95-1.48-4.75-1.13-11.33-2.53-18.93-1.41-7.6-5.49-10.98-9.15-12.67s-8.31-.14-7.6.84c.7.99 6.05 2.82 9.29 8.73s1.69 19.71 5.21 29.56 10 13.09 10 13.09-3.66 1.69-5.63 2.11-7.32 1.41-12.25.39c-5.13-1.06-8.59-4.82-9.15-8.97-.48-3.53 1.83-9.71.56-10s-5.81 6.19-5.95 11.54 3.98 11.54 10.17 14.5 19.15.28 19.15.28-1.06 1.62-1.2 4.72-1.97 10.03-5.28 12.04c-2.27 1.38-4.29 1.83-5 0-.7-1.83 2.89-2.53 2.75-4.36s-3.1-2.29-5.91-.56c-1.9 1.16-5.07 5.35-3.1 9.85s6.86 6.09 12.25 4.65c8.04-2.15 17.32-17.03 20.27-19.57 2.96-2.53 4.93-1.83 4.93-1.83s-1.41 13.09-1.13 21.96 5.95 14.66 12.25 13.66c7.04-1.13 7.46-6.9 6.34-10-.99-2.71-4.72-3.73-5.77-2.96-1.37 1.01-.46 2.67.07 3.13 1.27 1.09.21 3.63-1.76 3.06-1.97-.56-.14-7.18.7-10.42s2.82-10.84 5.07-11.4 4.54 3.39 6.62 5.77c3.56 4.08 9.36 7.25 17.63 7.39 10.93.19 17.7-6.55 19.25-8.24 1.52-1.68 4.19-5.48 2.51-5.62M93.13 60.9c3.24-2.25 6.01-3.28 6.01-3.28s.09 11.54-4.32 17.5c-3.65 4.93-7.18 3.8-7.18 3.8s3.63-1.98 3.94-5.77c.42-5.21-5.07-6.19-5.07-6.19s3.8-4.1 6.62-6.06",
    fill: "#ff615e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.09 53.93s11.59-3.45 10.46-11.9-9.67-10.32-9.67-10.32-1.22 4.41-1.03 10.18c.09 2.53.24 12.04.24 12.04",
    fill: "#ff615e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.53 75.6c-1.29 2.06-3.49 2.49-5.09 1.49s-1.85-3.01-.56-5.07 3.93-2.99 5.54-1.99 1.4 3.51.11 5.57m-22.2-12.1c1.8-.11 1.2-1.9.84-4.29-.35-2.39-1.65-8.68 2.04-12.46 3.1-3.17 6.96-3.13 9.85-1.27 2.18 1.41 3.17 1.97 4.01.92.56-.7-.28-2.04-1.69-3.24-1.79-1.52-7.95-4.65-13.73.14-5.46 4.53-4.58 13.3-3.87 16.33.72 3.03 1.42 3.94 2.55 3.87M47.66 35.13c-3.66 3.8-4.41 6.84-4.01 11.97.35 4.58 1.97 8.09 3.73 7.39 1.47-.59.84-3.31.35-4.72s-1.34-8.17 2.25-11.83 7.67-3.17 9.5-2.75 2.6.84 3.52-.21-.99-2.75-2.82-3.17-7.68-1.7-12.52 3.32",
    fill: "#a52914"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.01 57.66c0 2.92-2.19 5.85-5.07 5.7-2.82-.14-4.15-2.86-4.15-5.77s1.69-5.28 4.65-5.49c3.37-.24 4.57 2.64 4.57 5.56",
    fill: "#2c2b2d"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-80.881 108.76 47.472)",
    cx: 108.76,
    cy: 47.48,
    rx: 2.21,
    ry: 2.11,
    fill: "#fcd4b0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-69.403 110.681 33.493)",
    cx: 110.68,
    cy: 33.5,
    rx: 2.16,
    ry: 1.88,
    fill: "#fcd4b0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.76,
    cy: 63.15,
    rx: 2.58,
    ry: 2.67,
    fill: "#fcd4b0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-66.078 106.312 78.94)",
    cx: 106.32,
    cy: 78.94,
    rx: 2.78,
    ry: 2.62,
    fill: "#fcd4b0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-23.045 110.015 103.459)",
    cx: 110.01,
    cy: 103.45,
    rx: 2.11,
    ry: 1.89,
    fill: "#fcd4b0"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.58,
    cy: 106.7,
    rx: 2.39,
    ry: 2.25,
    fill: "#fcd4b0"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.74,
    cy: 104.25,
    rx: 2.3,
    ry: 2.39,
    fill: "#fcd4b0"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.9,
    cy: 120.82,
    rx: 2.49,
    ry: 2.44,
    fill: "#fcd4b0"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-3.887 53.552 106.772)",
    cx: 53.58,
    cy: 106.77,
    rx: 1.74,
    ry: 2.33,
    fill: "#fcd4b0"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-42.739 40.62 102.56)",
    cx: 40.62,
    cy: 102.57,
    rx: 2.58,
    ry: 2.3,
    fill: "#fcd4b0"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.33,
    cy: 108.25,
    rx: 2.58,
    ry: 2.35,
    fill: "#fcd4b0"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7,
    cy: 82.44,
    rx: 2.3,
    ry: 2.06,
    fill: "#fcd4b0"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-60 13.92 79.05)",
    cx: 13.92,
    cy: 79.05,
    rx: 2.16,
    ry: 2.25,
    fill: "#fcd4b0"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.009 6.902 70.33)",
    cx: 6.9,
    cy: 70.33,
    rx: 1.86,
    ry: 2.16,
    fill: "#fcd4b0"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.2,
    cy: 51.49,
    rx: 2.21,
    ry: 2.3,
    fill: "#fcd4b0"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.97,
    cy: 38.32,
    rx: 2.16,
    ry: 2.25,
    fill: "#fcd4b0"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-21.199 22.17 26.605)",
    cx: 22.17,
    cy: 26.6,
    rx: 1.92,
    ry: 2.11,
    fill: "#fcd4b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctopus);
export default __webpack_public_path__ + "static/media/octopus.7b0c73a4a46c0163c644b29c82faad7a.svg";
export { ForwardRef as ReactComponent };